/* Cargo Butler — 120 vehicle fitment database. Generated 2026-06-02. */
window.CB_VEHICLES = 
[
  {
    "brand": "Ford",
    "model": "Ford F-150",
    "bed": "5'7\" Short Bed",
    "len": 1704,
    "width": 1285,
    "type": "truck"
  },
  {
    "brand": "Ford",
    "model": "Ford F-150",
    "bed": "6'6\" Standard Bed",
    "len": 2004,
    "width": 1285,
    "type": "truck"
  },
  {
    "brand": "Ford",
    "model": "Ford F-150",
    "bed": "8'1\" Long Bed",
    "len": 2479,
    "width": 1285,
    "type": "truck"
  },
  {
    "brand": "Ford",
    "model": "Ford F-250 Super Duty",
    "bed": "6'9\" Bed",
    "len": 2080,
    "width": 1283,
    "type": "truck"
  },
  {
    "brand": "Ford",
    "model": "Ford F-250 Super Duty",
    "bed": "8' Bed",
    "len": 2492,
    "width": 1283,
    "type": "truck"
  },
  {
    "brand": "Ford",
    "model": "Ford F-350 Super Duty",
    "bed": "6'9\" Bed",
    "len": 2080,
    "width": 1283,
    "type": "truck"
  },
  {
    "brand": "Ford",
    "model": "Ford F-350 Super Duty",
    "bed": "8' Bed",
    "len": 2492,
    "width": 1283,
    "type": "truck"
  },
  {
    "brand": "Ford",
    "model": "Ford Ranger",
    "bed": "5' Bed",
    "len": 1514,
    "width": 1224,
    "type": "truck"
  },
  {
    "brand": "Ford",
    "model": "Ford Maverick",
    "bed": "4'6\" Bed",
    "len": 1382,
    "width": 1082,
    "type": "truck"
  },
  {
    "brand": "Ford",
    "model": "Ford F-150 Lightning (EV)",
    "bed": "5'6\" Short Bed",
    "len": 1704,
    "width": 1285,
    "type": "truck"
  },
  {
    "brand": "Ford",
    "model": "Ford Bronco (4-Door)",
    "bed": "Cargo (seats folded)",
    "len": 1778,
    "width": 1346,
    "type": "suv"
  },
  {
    "brand": "Ford",
    "model": "Ford Bronco Sport",
    "bed": "Cargo (seats folded)",
    "len": 1600,
    "width": 1295,
    "type": "suv"
  },
  {
    "brand": "Ford",
    "model": "Ford Explorer",
    "bed": "Cargo (all seats folded)",
    "len": 2083,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Ford",
    "model": "Ford Expedition",
    "bed": "Cargo (all seats folded)",
    "len": 2362,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Ford",
    "model": "Ford Expedition Max",
    "bed": "Cargo (all seats folded)",
    "len": 2819,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Ford",
    "model": "Ford Escape",
    "bed": "Cargo (seats folded)",
    "len": 1778,
    "width": 1219,
    "type": "suv"
  },
  {
    "brand": "Ford",
    "model": "Ford Mustang Mach-E (EV)",
    "bed": "Cargo (seats folded)",
    "len": 1600,
    "width": 1219,
    "type": "suv"
  },
  {
    "brand": "Ford",
    "model": "Ford Transit Connect Van",
    "bed": "Cargo (seats folded)",
    "len": 2413,
    "width": 1219,
    "type": "van"
  },
  {
    "brand": "Chevrolet",
    "model": "Chevrolet Silverado 1500",
    "bed": "5'9\" Short Bed",
    "len": 1776,
    "width": 1286,
    "type": "truck"
  },
  {
    "brand": "Chevrolet",
    "model": "Chevrolet Silverado 1500",
    "bed": "6'7\" Standard Bed",
    "len": 2018,
    "width": 1286,
    "type": "truck"
  },
  {
    "brand": "Chevrolet",
    "model": "Chevrolet Silverado 1500",
    "bed": "8'2\" Long Bed",
    "len": 2494,
    "width": 1286,
    "type": "truck"
  },
  {
    "brand": "Chevrolet",
    "model": "Chevrolet Colorado",
    "bed": "5'2\" Bed",
    "len": 1567,
    "width": 1128,
    "type": "truck"
  },
  {
    "brand": "Chevrolet",
    "model": "Chevrolet Silverado 2500 HD",
    "bed": "6'9\" Std Bed",
    "len": 2057,
    "width": 1286,
    "type": "truck"
  },
  {
    "brand": "Chevrolet",
    "model": "Chevrolet Silverado 2500 HD",
    "bed": "8'2\" Long Bed",
    "len": 2494,
    "width": 1286,
    "type": "truck"
  },
  {
    "brand": "Chevrolet",
    "model": "Chevrolet Silverado 3500 HD",
    "bed": "6'9\" Std Bed",
    "len": 2057,
    "width": 1286,
    "type": "truck"
  },
  {
    "brand": "Chevrolet",
    "model": "Chevrolet Silverado 3500 HD",
    "bed": "8'2\" Long Bed",
    "len": 2494,
    "width": 1286,
    "type": "truck"
  },
  {
    "brand": "Chevrolet",
    "model": "Chevrolet Silverado EV",
    "bed": "5'11\" Bed",
    "len": 1804,
    "width": 1286,
    "type": "truck"
  },
  {
    "brand": "Chevrolet",
    "model": "Chevrolet Tahoe",
    "bed": "Cargo (all seats folded)",
    "len": 2388,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Chevrolet",
    "model": "Chevrolet Suburban",
    "bed": "Cargo (all seats folded)",
    "len": 3048,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Chevrolet",
    "model": "Chevrolet Traverse",
    "bed": "Cargo (all seats folded)",
    "len": 2235,
    "width": 1321,
    "type": "suv"
  },
  {
    "brand": "Chevrolet",
    "model": "Chevrolet Equinox",
    "bed": "Cargo (seats folded)",
    "len": 1702,
    "width": 1219,
    "type": "suv"
  },
  {
    "brand": "Chevrolet",
    "model": "Chevrolet Blazer",
    "bed": "Cargo (seats folded)",
    "len": 1854,
    "width": 1219,
    "type": "suv"
  },
  {
    "brand": "GMC",
    "model": "GMC Sierra 1500",
    "bed": "5'9\" Short Bed",
    "len": 1776,
    "width": 1286,
    "type": "truck"
  },
  {
    "brand": "GMC",
    "model": "GMC Sierra 1500",
    "bed": "6'7\" Standard Bed",
    "len": 2018,
    "width": 1286,
    "type": "truck"
  },
  {
    "brand": "GMC",
    "model": "GMC Sierra 1500",
    "bed": "8'2\" Long Bed",
    "len": 2494,
    "width": 1286,
    "type": "truck"
  },
  {
    "brand": "GMC",
    "model": "GMC Canyon",
    "bed": "5'2\" Bed",
    "len": 1567,
    "width": 1128,
    "type": "truck"
  },
  {
    "brand": "GMC",
    "model": "GMC Sierra 2500 HD",
    "bed": "6'9\" Std Bed",
    "len": 2057,
    "width": 1286,
    "type": "truck"
  },
  {
    "brand": "GMC",
    "model": "GMC Sierra 2500 HD",
    "bed": "8'2\" Long Bed",
    "len": 2494,
    "width": 1286,
    "type": "truck"
  },
  {
    "brand": "GMC",
    "model": "GMC Sierra 3500 HD",
    "bed": "6'9\" Std Bed",
    "len": 2057,
    "width": 1286,
    "type": "truck"
  },
  {
    "brand": "GMC",
    "model": "GMC Sierra 3500 HD",
    "bed": "8'2\" Long Bed",
    "len": 2494,
    "width": 1286,
    "type": "truck"
  },
  {
    "brand": "GMC",
    "model": "GMC Hummer EV Pickup",
    "bed": "5' Bed",
    "len": 1524,
    "width": 1270,
    "type": "truck"
  },
  {
    "brand": "GMC",
    "model": "GMC Yukon",
    "bed": "Cargo (all seats folded)",
    "len": 2388,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "GMC",
    "model": "GMC Yukon XL",
    "bed": "Cargo (all seats folded)",
    "len": 3048,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "GMC",
    "model": "GMC Acadia",
    "bed": "Cargo (all seats folded)",
    "len": 2032,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Ram",
    "model": "Ram 1500",
    "bed": "5'7\" Short Bed",
    "len": 1702,
    "width": 1295,
    "type": "truck"
  },
  {
    "brand": "Ram",
    "model": "Ram 1500",
    "bed": "6'4\" Long Bed",
    "len": 1938,
    "width": 1295,
    "type": "truck"
  },
  {
    "brand": "Ram",
    "model": "Ram 2500 / 3500",
    "bed": "6'4\" Bed",
    "len": 1938,
    "width": 1295,
    "type": "truck"
  },
  {
    "brand": "Ram",
    "model": "Ram 2500 / 3500",
    "bed": "8' Bed",
    "len": 2497,
    "width": 1295,
    "type": "truck"
  },
  {
    "brand": "Ram",
    "model": "Dodge Durango (Ram group)",
    "bed": "Cargo (all seats folded)",
    "len": 2057,
    "width": 1245,
    "type": "suv"
  },
  {
    "brand": "Ram",
    "model": "Ram ProMaster City",
    "bed": "Cargo bay",
    "len": 2210,
    "width": 1219,
    "type": "van"
  },
  {
    "brand": "Ram",
    "model": "Ram ProMaster Cargo Van",
    "bed": "Cargo bay (135\" WB)",
    "len": 3023,
    "width": 1448,
    "type": "van"
  },
  {
    "brand": "Toyota",
    "model": "Toyota Tundra",
    "bed": "5'6\" Short Bed",
    "len": 1676,
    "width": 1232,
    "type": "truck"
  },
  {
    "brand": "Toyota",
    "model": "Toyota Tundra",
    "bed": "6'6\" Standard Bed",
    "len": 1981,
    "width": 1232,
    "type": "truck"
  },
  {
    "brand": "Toyota",
    "model": "Toyota Tundra",
    "bed": "8'1\" Long Bed",
    "len": 2464,
    "width": 1232,
    "type": "truck"
  },
  {
    "brand": "Toyota",
    "model": "Toyota Tacoma",
    "bed": "5' Short Bed",
    "len": 1537,
    "width": 1054,
    "type": "truck"
  },
  {
    "brand": "Toyota",
    "model": "Toyota Tacoma",
    "bed": "6' Long Bed",
    "len": 1872,
    "width": 1054,
    "type": "truck"
  },
  {
    "brand": "Toyota",
    "model": "Toyota RAV4",
    "bed": "Cargo (seats folded)",
    "len": 1829,
    "width": 1295,
    "type": "suv"
  },
  {
    "brand": "Toyota",
    "model": "Toyota Highlander",
    "bed": "Cargo (all seats folded)",
    "len": 2083,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Toyota",
    "model": "Toyota Grand Highlander",
    "bed": "Cargo (all seats folded)",
    "len": 2286,
    "width": 1321,
    "type": "suv"
  },
  {
    "brand": "Toyota",
    "model": "Toyota 4Runner",
    "bed": "Cargo (seats folded)",
    "len": 2235,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Toyota",
    "model": "Toyota Land Cruiser",
    "bed": "Cargo (seats folded)",
    "len": 1930,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Toyota",
    "model": "Toyota Sequoia",
    "bed": "Cargo (all seats folded)",
    "len": 2337,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Toyota",
    "model": "Toyota Sienna",
    "bed": "Cargo (all seats folded)",
    "len": 2235,
    "width": 1270,
    "type": "van"
  },
  {
    "brand": "Toyota",
    "model": "Toyota Camry",
    "bed": "Trunk",
    "len": 1067,
    "width": 991,
    "type": "sedan"
  },
  {
    "brand": "Nissan",
    "model": "Nissan Frontier",
    "bed": "5' Bed",
    "len": 1511,
    "width": 1130,
    "type": "truck"
  },
  {
    "brand": "Nissan",
    "model": "Nissan Frontier",
    "bed": "6' Bed",
    "len": 1862,
    "width": 1130,
    "type": "truck"
  },
  {
    "brand": "Nissan",
    "model": "Nissan Titan",
    "bed": "5'6\" Bed",
    "len": 1702,
    "width": 1270,
    "type": "truck"
  },
  {
    "brand": "Nissan",
    "model": "Nissan Titan XD",
    "bed": "6'6\" Bed",
    "len": 2001,
    "width": 1270,
    "type": "truck"
  },
  {
    "brand": "Nissan",
    "model": "Nissan Armada",
    "bed": "Cargo (all seats folded)",
    "len": 2261,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Nissan",
    "model": "Nissan Pathfinder",
    "bed": "Cargo (all seats folded)",
    "len": 2032,
    "width": 1219,
    "type": "suv"
  },
  {
    "brand": "Nissan",
    "model": "Nissan Rogue",
    "bed": "Cargo (seats folded)",
    "len": 1778,
    "width": 1219,
    "type": "suv"
  },
  {
    "brand": "Nissan",
    "model": "Nissan Murano",
    "bed": "Cargo (seats folded)",
    "len": 1981,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Honda",
    "model": "Honda Ridgeline",
    "bed": "5'4\" Bed",
    "len": 1626,
    "width": 1270,
    "type": "truck"
  },
  {
    "brand": "Honda",
    "model": "Honda CR-V",
    "bed": "Cargo (seats folded)",
    "len": 1829,
    "width": 1245,
    "type": "suv"
  },
  {
    "brand": "Honda",
    "model": "Honda Pilot",
    "bed": "Cargo (all seats folded)",
    "len": 2108,
    "width": 1321,
    "type": "suv"
  },
  {
    "brand": "Honda",
    "model": "Honda Passport",
    "bed": "Cargo (seats folded)",
    "len": 1981,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Honda",
    "model": "Honda Odyssey",
    "bed": "Cargo (Magic Seat in floor)",
    "len": 2438,
    "width": 1270,
    "type": "van"
  },
  {
    "brand": "Honda",
    "model": "Honda Accord",
    "bed": "Trunk",
    "len": 1118,
    "width": 1016,
    "type": "sedan"
  },
  {
    "brand": "Jeep",
    "model": "Jeep Gladiator",
    "bed": "5' Bed",
    "len": 1524,
    "width": 1138,
    "type": "truck"
  },
  {
    "brand": "Jeep",
    "model": "Jeep Wrangler 4-Door",
    "bed": "Cargo (seats folded)",
    "len": 1702,
    "width": 1422,
    "type": "suv"
  },
  {
    "brand": "Jeep",
    "model": "Jeep Grand Cherokee",
    "bed": "Cargo (seats folded)",
    "len": 1981,
    "width": 1219,
    "type": "suv"
  },
  {
    "brand": "Jeep",
    "model": "Jeep Grand Cherokee L",
    "bed": "Cargo (all seats folded)",
    "len": 2159,
    "width": 1245,
    "type": "suv"
  },
  {
    "brand": "Jeep",
    "model": "Jeep Wagoneer",
    "bed": "Cargo (all seats folded)",
    "len": 2311,
    "width": 1295,
    "type": "suv"
  },
  {
    "brand": "Jeep",
    "model": "Jeep Wagoneer L",
    "bed": "Cargo (all seats folded)",
    "len": 2870,
    "width": 1295,
    "type": "suv"
  },
  {
    "brand": "Jeep",
    "model": "Jeep Compass",
    "bed": "Cargo (seats folded)",
    "len": 1727,
    "width": 1219,
    "type": "suv"
  },
  {
    "brand": "Hyundai",
    "model": "Hyundai Santa Cruz",
    "bed": "4'4\" Bed",
    "len": 1323,
    "width": 1085,
    "type": "truck"
  },
  {
    "brand": "Hyundai",
    "model": "Hyundai Palisade",
    "bed": "Cargo (all seats folded)",
    "len": 2159,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Hyundai",
    "model": "Hyundai Tucson",
    "bed": "Cargo (seats folded)",
    "len": 1778,
    "width": 1219,
    "type": "suv"
  },
  {
    "brand": "Hyundai",
    "model": "Hyundai Santa Fe",
    "bed": "Cargo (all seats folded)",
    "len": 2032,
    "width": 1245,
    "type": "suv"
  },
  {
    "brand": "Rivian",
    "model": "Rivian R1T",
    "bed": "4'6\" Bed",
    "len": 1372,
    "width": 1270,
    "type": "truck"
  },
  {
    "brand": "Rivian",
    "model": "Rivian R1S",
    "bed": "Cargo (all seats folded)",
    "len": 1905,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Tesla",
    "model": "Tesla Cybertruck",
    "bed": "6' Bed",
    "len": 1852,
    "width": 1295,
    "type": "truck"
  },
  {
    "brand": "Tesla",
    "model": "Tesla Model X",
    "bed": "Cargo (seats folded)",
    "len": 1854,
    "width": 1245,
    "type": "suv"
  },
  {
    "brand": "Tesla",
    "model": "Tesla Model Y",
    "bed": "Cargo (seats folded)",
    "len": 1727,
    "width": 1220,
    "type": "suv"
  },
  {
    "brand": "Tesla",
    "model": "Tesla Model S",
    "bed": "Trunk + folded rear seats",
    "len": 1880,
    "width": 1092,
    "type": "sedan"
  },
  {
    "brand": "Tesla",
    "model": "Tesla Model 3",
    "bed": "Trunk + folded rear seats",
    "len": 1626,
    "width": 1016,
    "type": "sedan"
  },
  {
    "brand": "Kia",
    "model": "Kia Telluride",
    "bed": "Cargo (all seats folded)",
    "len": 2159,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Kia",
    "model": "Kia Sportage",
    "bed": "Cargo (seats folded)",
    "len": 1778,
    "width": 1219,
    "type": "suv"
  },
  {
    "brand": "Kia",
    "model": "Kia Sorento",
    "bed": "Cargo (all seats folded)",
    "len": 2057,
    "width": 1245,
    "type": "suv"
  },
  {
    "brand": "Kia",
    "model": "Kia Carnival",
    "bed": "Cargo (all seats folded)",
    "len": 2261,
    "width": 1270,
    "type": "van"
  },
  {
    "brand": "Subaru",
    "model": "Subaru Outback",
    "bed": "Cargo (seats folded)",
    "len": 1905,
    "width": 1245,
    "type": "suv"
  },
  {
    "brand": "Subaru",
    "model": "Subaru Forester",
    "bed": "Cargo (seats folded)",
    "len": 1930,
    "width": 1346,
    "type": "suv"
  },
  {
    "brand": "Subaru",
    "model": "Subaru Ascent",
    "bed": "Cargo (all seats folded)",
    "len": 2032,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Mazda",
    "model": "Mazda CX-5",
    "bed": "Cargo (seats folded)",
    "len": 1778,
    "width": 1219,
    "type": "suv"
  },
  {
    "brand": "Mazda",
    "model": "Mazda CX-9 / CX-90",
    "bed": "Cargo (all seats folded)",
    "len": 1981,
    "width": 1219,
    "type": "suv"
  },
  {
    "brand": "Buick",
    "model": "Buick Enclave",
    "bed": "Cargo (all seats folded)",
    "len": 2159,
    "width": 1321,
    "type": "suv"
  },
  {
    "brand": "Lincoln",
    "model": "Lincoln Navigator",
    "bed": "Cargo (all seats folded)",
    "len": 2362,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Lincoln",
    "model": "Lincoln Aviator",
    "bed": "Cargo (all seats folded)",
    "len": 2083,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Chrysler",
    "model": "Chrysler Pacifica",
    "bed": "Cargo (Stow 'n Go in floor)",
    "len": 2438,
    "width": 1219,
    "type": "van"
  },
  {
    "brand": "Chrysler",
    "model": "Chrysler Voyager",
    "bed": "Cargo (Stow 'n Go in floor)",
    "len": 2438,
    "width": 1219,
    "type": "van"
  },
  {
    "brand": "Dodge",
    "model": "Dodge Grand Caravan",
    "bed": "Cargo (seats folded)",
    "len": 2235,
    "width": 1219,
    "type": "van"
  },
  {
    "brand": "Volkswagen",
    "model": "Volkswagen Atlas",
    "bed": "Cargo (all seats folded)",
    "len": 2083,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Volkswagen",
    "model": "Volkswagen Tiguan",
    "bed": "Cargo (seats folded)",
    "len": 1778,
    "width": 1245,
    "type": "suv"
  },
  {
    "brand": "Lexus",
    "model": "Lexus LX 600",
    "bed": "Cargo (all seats folded)",
    "len": 1930,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Lexus",
    "model": "Lexus GX 550",
    "bed": "Cargo (all seats folded)",
    "len": 2057,
    "width": 1245,
    "type": "suv"
  },
  {
    "brand": "Land Rover",
    "model": "Land Rover Defender 110",
    "bed": "Cargo (seats folded)",
    "len": 1981,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Land Rover",
    "model": "Range Rover",
    "bed": "Cargo (seats folded)",
    "len": 2057,
    "width": 1270,
    "type": "suv"
  },
  {
    "brand": "Mercedes-Benz",
    "model": "Mercedes-Benz S-Class",
    "bed": "Trunk",
    "len": 1245,
    "width": 1092,
    "type": "sedan"
  },
  {
    "brand": "Mercedes-Benz",
    "model": "Mercedes EQS Sedan",
    "bed": "Trunk + folded rear seats",
    "len": 1727,
    "width": 1092,
    "type": "sedan"
  },
  {
    "brand": "BMW",
    "model": "BMW 7 Series",
    "bed": "Trunk",
    "len": 1245,
    "width": 1092,
    "type": "sedan"
  }
];
